import { Field } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FieldErrorMessage } from "..";

const GVModalTemplate = ({
  open,
  handleClose,
  formikProps,
  generationVariablesList,
  fieldName,
  modalTitle,
  nameAndPronoun,
  modalIcon,
  modalDescription,
  noSelectionText,
  createLink = "test",
  createText = "test",
}) => {
  const { t } = useTranslation();
  const currentProject = useSelector((state) => state?.project);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-lg">
        {/* Header */}
        <div className="flex items-center mb-4">
          {modalIcon && (
            <img src={modalIcon} alt="icon" className="w-10 h-10 mr-3" />
          )}
          <h3 className="text-2xl font-bold">
            {modalTitle}{" "}
            <span className="text-gray-500 text-sm">
              ({t("Optional", "Optionnel")})
            </span>
          </h3>
        </div>

        {/* Banner to prevent problems for having a GV now not associated with the project anymore */}
        {formikProps?.values.website !== currentProject.project.id &&
          currentProject && (
            <p className="bg-red-300 text-sm p-3 rounded-md mb-2">
              Attention : {nameAndPronoun} associé à cet article n'est pas
              associé au site web actuellement sélectionné. Pour pouvoir
              l'utiliser ici,{" "}
              <a
                target="_blank"
                href="/profile?tab=manage-variables"
                className="text-blue-50 hover:underline hover:text-blue-100"
              >
                associez-le au site web
              </a>
              .
            </p>
          )}

        {/* Description */}
        <p className="text-gray-700 mb-6">{modalDescription}</p>

        {/* Form Field */}
        <div className="mb-4">
          <label
            htmlFor={fieldName}
            className="block text-sm font-medium text-gray-700"
          >
            {modalTitle}
          </label>
          <Field
            as="select"
            name={fieldName}
            id={fieldName}
            className={`mt-1 block w-full p-2 border ${
              formikProps.touched[fieldName] && formikProps.errors[fieldName]
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500`}
          >
            <option value="">{`--${noSelectionText}--`}</option>
            {generationVariablesList?.map((item) => (
              <option key={`${fieldName}_${item.id}`} value={item.id}>
                {item.key}
              </option>
            ))}
          </Field>
          <FieldErrorMessage name={fieldName} />
          <a
            href={createLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 text-sm hover:underline"
          >
            {createText}
          </a>
        </div>

        {/* Close Button */}
        <button
          onClick={handleClose}
          className="w-full py-2 px-4 bg-gray_local-400 text-white rounded-md hover:bg-gray_local-400/70 transition duration-150"
        >
          {t("Close", "Fermer")}
        </button>
      </div>
    </div>
  );
};

export default GVModalTemplate;
